import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      {/* Logo */}
      <div className="flex justify-center">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center shadow-lg">
            <div className="text-white font-bold text-xl">T</div>
          </div>
          <div className="text-left">
            <h1 className="text-2xl font-bold text-primary">trick.bike</h1>
            <p className="text-sm text-muted-foreground">Smart bike tricks</p>
          </div>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h2 className="text-3xl font-bold text-foreground">Create Your Account</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Join thousands of riders analyzing their bike tricks and getting personalized upgrade recommendations
        </p>
      </div>

      {/* Benefits */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="Camera" size={16} color="var(--color-success)" />
          </div>
          <span>Trick Analysis</span>
        </div>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <div className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center">
            <Icon name="Zap" size={16} color="var(--color-accent)" />
          </div>
          <span>Smart Recommendations</span>
        </div>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <div className="w-8 h-8 bg-warning/10 rounded-full flex items-center justify-center">
            <Icon name="MapPin" size={16} color="var(--color-warning)" />
          </div>
          <span>Local Shop Finder</span>
        </div>
      </div>

      {/* Login Link */}
      <div className="flex items-center justify-center space-x-2 text-sm">
        <span className="text-muted-foreground">Already have an account?</span>
        <Button
          variant="link"
          size="sm"
          onClick={() => navigate('/login')}
          className="p-0 h-auto"
        >
          Sign in here
        </Button>
      </div>
    </div>
  );
};

export default RegistrationHeader;